/**
 * StatusBadge - Shared status badge component
 * @package @app/ui
 */

import { cn } from '../lib/utils';

const statusColors: Record<string, string> = {
  ACTIVE: 'bg-green-100 text-green-800',
  DRAFT: 'bg-muted text-muted-foreground',
  COMPLETED: 'bg-blue-100 text-blue-800',
  EXPIRED: 'bg-yellow-100 text-yellow-800',
  CANCELLED: 'bg-red-100 text-red-800',
  PENDING: 'bg-yellow-100 text-yellow-800',
  RECEIVED: 'bg-green-100 text-green-800',
  OVERDUE: 'bg-red-100 text-red-800',
  COMING_SOON: 'bg-amber-100 text-amber-800',
};

function formatLabel(status: string): string {
  return status
    .split('_')
    .map((word) => word.charAt(0) + word.slice(1).toLowerCase())
    .join(' ');
}

export function StatusBadge({
  status,
  size = 'sm',
  className,
}: {
  status: string;
  size?: 'sm' | 'md';
  className?: string;
}) {
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full whitespace-nowrap',
        size === 'sm' ? 'px-2 py-0.5 text-xs' : 'px-3 py-1 text-sm',
        statusColors[status] || 'bg-muted text-muted-foreground',
        className,
      )}
    >
      {formatLabel(status)}
    </span>
  );
}
